import { t } from 'i18next';
import { Rule } from 'antd/lib/form';
import { FormFieldConfig } from './CustomerInformationContent.utils';

export const ADDRESS_FORM_FIELDS_WITH_STATE: FormFieldConfig[] = [
  {
    name: 'streetAddress',
    label: t('Street address'),
    rules: [{ required: true, message: t('Please enter street address') }] as Rule[],
  },
  {
    name: 'city',
    label: t('City'),
    rules: [{ required: true, message: t('Please enter city') }] as Rule[],
  },
  {
    name: 'state',
    label: t('State'),
    rules: [{ required: true, message: t('Please enter state') }] as Rule[],
  },
  {
    name: 'zipCode',
    label: t('ZIP code'),
    rules: [{ required: true, message: t('Please enter valid ZIP code') }] as Rule[],
  },
  {
    name: 'country',
    label: t('Country'),
    rules: [{ required: false, message: t('Please enter country') }] as Rule[],
  },
];

export const ADDRESS_FORM_FIELDS: FormFieldConfig[] = [
  {
    name: 'streetAddress',
    label: t('Street address'),
    rules: [{ required: true, message: t('Please enter street address') }] as Rule[],
  },
  {
    name: 'city',
    label: t('City'),
    rules: [{ required: true, message: t('Please enter city') }] as Rule[],
  },
  {
    name: 'country',
    label: t('Country'),
    rules: [{ required: true, message: t('Please enter country') }] as Rule[],
  },
  {
    name: 'zipCode',
    label: t('ZIP code'),
    rules: [{ required: true, message: t('Please enter valid ZIP code') }] as Rule[],
  },
];

export const ACCOUNT_MANAGER_FORM_FIELDS: FormFieldConfig[] = [
  {
    name: 'fullName',
    label: t('Full Name'),
    rules: [] as Rule[],
  },
];

export const MODAL_CONFIGS = {
  ADDRESS: {
    title: t('Edit site address'),
    description: t('This address will be used for the shipment of equipment'),
    fields: {
      AMERICAS: ADDRESS_FORM_FIELDS_WITH_STATE,
      EMEIA: ADDRESS_FORM_FIELDS,
      APAC: ADDRESS_FORM_FIELDS,
    },
  },
  ACCOUNT_MANAGER: {
    title: t('Edit Account Manager'),
    description: '',
    fields: ACCOUNT_MANAGER_FORM_FIELDS,
  },
} as const;
